var render, staticRenderFns
import script from "./DraggableItem.vue?vue&type=script&lang=js&"
export * from "./DraggableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\项目管理\\旧换新\\源码\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74970283')) {
      api.createRecord('74970283', component.options)
    } else {
      api.reload('74970283', component.options)
    }
    
  }
}
component.options.__file = "src/components/FormGenerator/index/DraggableItem.vue"
export default component.exports